// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__12yKh","message":"CookieConsent_message__1BRHj","cookieLink":"CookieConsent_cookieLink__2LOyv","continueBtn":"CookieConsent_continueBtn__1R7U6"};